import React from "react";
import loc from "../../../../assets/img/admin/res/location.svg";
const AdminResidancesAddress = ({inforesidencedetail}) => {
  return (
    <div className="AdminBox">
      <div className="flex gap-[8px] items-center">
        <img src={loc} />
        <p className="text-[#292D32] text-[20px] font-[700]">آدرس اقامتگاه</p>
      </div>
      <p className="text-[#5B5F64] text-[14px] font-[400] mb-[24px] mr-[37px]">
        آدرس دقیق اقامتگاه تنها برای میزبان و مدیر وبسایت قابل مشاهده ست{" "}
      </p>
      <p className="text-[#12171C] text-[18px] font-[500] AdminBox-shodow p-[20px]  ">
     {inforesidencedetail.address}
      </p>
    </div>
  );
};

export default AdminResidancesAddress;
